import { useCallback, useEffect, useRef, useState } from 'react'
import debounce from 'lodash/debounce'
import { DebouncedFunc } from 'lodash'

export const useDebouncedState = <T>(initialState: T, delay: number = 350): [T, T, (v: T) => void] => {
  const [value, setValue] = useState<T>(initialState)
  const [debouncedValue, setDebouncedValue] = useState<T>(initialState)
  const debouncedSetValue = useRef(debounce(setDebouncedValue, delay))
  const setValueReal = useCallback(
    (value: T) => {
      setValue(value)
      debouncedSetValue.current(value)
    },
    [setValue]
  )
  return [value, debouncedValue, setValueReal]
}
